import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "selectBoxBtm" }
const _hoisted_2 = {
  key: 0,
  class: "selList"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "selListOneIn" }
const _hoisted_5 = {
  key: 1,
  class: "selListNo"
}
const _hoisted_6 = { class: "btmBtn" }

import { ref, onMounted, getCurrentInstance, reactive, nextTick,watch } from 'vue'
import {ArrowDown, ArrowUp,} from "@element-plus/icons-vue";
import { useRouter,useRoute } from "vue-router";

export default /*@__PURE__*/_defineComponent({
  __name: 'selectBox',
  props: {
    allShow:  {
        type: Boolean,
        required: true,
        default: true,
    },
    newShow: {
        type: Boolean,
        required: true,
        default: true,
    }
    },
  emits: ['changeSelect'],
  setup(__props, { expose: __expose, emit: __emit }) {

const route=useRoute()
const router = useRouter();
const selToshow=ref(false)
const tabSelect=()=>{
    selToshow.value=!selToshow.value
}
const closes=()=>{
    selToshow.value=false
}
const proList=ref([])
const props = __props
watch(route, (to, from) => {
    proList.value=JSON.parse(localStorage.getItem('projectoften')) || []
})
onMounted(()=>{
    proList.value=JSON.parse(localStorage.getItem('projectoften')) || []
    // console.log(proList.value)
})
// 所有项目
const allProject = () => {
    selToshow.value=false
    router.push("/index/aiApply/projectList")
    localStorage.removeItem('captionTree')
}
//新项目
const newProject=()=>{
    selToshow.value=false
    router.push("/index/aiApply/project")
}
const emit = __emit
const changeSelect = (e:any) => {
    
    // router.push({ path: '/index/aiApply/captionsEdit', query: { subtitleId: e.subtitleId } })
    emit('changeSelect',e.subtitleId)
    selToshow.value=false
}
__expose({
    closes,
})

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "selectBox",
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", {
      class: "selectBoxInner",
      onClick: _withModifiers(tabSelect, ["stop"])
    }, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "selectText" }, " 最近项目 ", -1)),
      _createElementVNode("div", null, [
        _withDirectives(_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_unref(ArrowDown))
          ]),
          _: 1
        }, 512), [
          [_vShow, !selToshow.value]
        ]),
        _withDirectives(_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_unref(ArrowUp))
          ]),
          _: 1
        }, 512), [
          [_vShow, selToshow.value]
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      (proList.value.length>0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(proList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "selListOne",
                key: index,
                onClick: _withModifiers(($event: any) => (changeSelect(item)), ["stop"])
              }, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(item.title), 1)
              ], 8, _hoisted_3))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (proList.value.length==0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 暂无项目 "))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("span", {
          onClick: _withModifiers(allProject, ["stop"])
        }, "所有项目", 512), [
          [_vShow, props.allShow]
        ]),
        _withDirectives(_createElementVNode("span", {
          onClick: _withModifiers(newProject, ["stop"])
        }, "新项目", 512), [
          [_vShow, props.newShow]
        ])
      ])
    ], 512), [
      [_vShow, selToshow.value]
    ])
  ]))
}
}

})